import {
    SYSTEM_CHOOSE_CURRENT_USERTAG,
} from './constants';
  
export function chooseCurrentUserTag(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_USERTAG,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_USERTAG:
        return {
          ...state,
          currentUserTag:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentUserTag.js